import Client from './Clients/Axios/AxiosClient';
import {
  getAuthorizedHeader,
  getAuthorizedHeaderWithCompanyCode,
} from './utils';

const resource = '/user';

function normalizeCurrency(value) {
  return typeof value === 'string'
    ? value.trim().toUpperCase()
    : null;
}

function normalizeCompany(company) {
  if (!company || typeof company !== 'object') {
    return company;
  }

  return {
    ...company,
    currency: normalizeCurrency(company?.currency),
    CategoriaABC: company?.CategoriaABC ?? null,
  };
}

function normalizeContacts(contacts) {
  if (!Array.isArray(contacts)) return contacts;

  return contacts.map((contact) => ({
    ...contact,
    companies: Array.isArray(contact?.companies)
      ? contact.companies.map(normalizeCompany)
      : contact?.companies,
  }));
}

function normalizeHeadquarters(headquarters) {
  if (!Array.isArray(headquarters)) return headquarters;

  return headquarters.map((headquarter) => ({
    ...headquarter,
    headquarter_currency: normalizeCurrency(
      headquarter?.headquarter_currency
    ),
    companies: Array.isArray(headquarter?.companies)
      ? headquarter.companies.map(normalizeCompany)
      : headquarter?.companies,
  }));
}

function normalizeAuthenticationResponse(response) {
  const user = response?.data?.user;

  if (!user) {
    return response;
  }

  return {
    ...response,
    data: {
      ...response.data,
      user: {
        ...user,
        contacts: normalizeContacts(user?.contacts),
        headquarters: normalizeHeadquarters(user?.headquarters),
      },
    },
  };
}

export default {
  async authentication(userEmail, userPassword, isEmail = true) {
    try {
      // correo > auth
      // contacto > etl
      const endpoint = isEmail
        ? `${resource}/authorization?no_cache=${Date.now()}`
        : `etl/access_besafer/?no_cache=${Date.now()}`;

      const data = {
        email: userEmail,
        password: userPassword,
      };

      if (!isEmail) {
        data.Usuario = userEmail;
        data.Password = userPassword;
      }

      const response = await Client.post(`${endpoint}`, data);
      return Promise.resolve(
        normalizeAuthenticationResponse(response)
      );
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async logLogin(
    userId,
    email,
    username,
    accessToken,
    companyCode,
    addressCode = null,
    contactCode = null
  ) {
    return Client.post(
      `${resource}/log_login?no_cache=${Date.now()}`,
      {
        user_id: userId,
        email,
        username,
        company: companyCode,
        origin: 'web',
      },
      getAuthorizedHeaderWithCompanyCode(
        accessToken,
        companyCode,
        addressCode,
        contactCode
      )
    );
  },

  confirmResetPassword(tokenFromQueryParam) {
    return Client.post(
      `${resource}/confirm_password?no_cache=${Date.now()}`,
      {
        token: tokenFromQueryParam,
      }
    );
  },

  get(accessToken) {
    return Client.get(
      `${resource}?no_cache=${Date.now()}`,
      getAuthorizedHeader(accessToken)
    );
  },

  refreshAccessToken(refreshToken) {
    return Client.post(`${resource}/refresh?no_cache=${Date.now()}`, {
      refresh: refreshToken,
    });
  },

  resetPassword(email) {
    const language = navigator.language || navigator.userLanguage;
    return Client.post(
      `${resource}/reset_password?no_cache=${Date.now()}`,
      {
        email,
        language,
      }
    );
  },

  update(
    userDataObjectToUpdate,
    accessToken,
    userCompanyCode,
    addressCode
  ) {
    return Client.put(
      `${resource}?no_cache=${Date.now()}`,
      userDataObjectToUpdate,
      getAuthorizedHeaderWithCompanyCode(
        accessToken,
        userCompanyCode,
        addressCode,
        userDataObjectToUpdate.code
      )
    );
  },

  updateEmail(newEmail, accessToken) {
    return Client.post(
      `${resource}/reset_password?no_cache=${Date.now()}`,
      {
        newEmail,
      },
      getAuthorizedHeader(accessToken)
    );
  },

  updatePassword(
    newPassword,
    oldPassword,
    accessToken,
    userCompanyCode
  ) {
    return Client.put(
      `${resource}/password?no_cache=${Date.now()}`,
      {
        new_password: newPassword,
        old_password: oldPassword,
      },
      getAuthorizedHeaderWithCompanyCode(accessToken, userCompanyCode)
    );
  },
};
